"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponErrorCodes = void 0;
var CouponErrorCodes;
(function (CouponErrorCodes) {
    CouponErrorCodes["ALREADY_A_USER"] = "ALREADY_A_USER";
    CouponErrorCodes["SELF_REFERRAL"] = "SELF_REFERRAL";
    CouponErrorCodes["EXPIRED"] = "EXPIRED";
    CouponErrorCodes["NON_EXISTING"] = "NON_EXISTING";
    CouponErrorCodes["QUANTITY_EXCEEDED"] = "QUANTITY_EXCEEDED";
    CouponErrorCodes["REDEMPTIONS_PER_CUSTOMER_EXCEEDED"] = "REDEMPTIONS_PER_CUSTOMER_EXCEEDED";
    CouponErrorCodes["ALREADY_LOADED_COUPON"] = "ALREADY_LOADED";
    CouponErrorCodes["GIFT_CARD_EMPTY"] = "GIFT_CARD_EMPTY";
    CouponErrorCodes["GIFT_CARD_INACTIVE"] = "GIFT_CARD_INACTIVE";
    CouponErrorCodes["UPSELL_EXPIRED"] = "UPSELL_EXPIRED";
})(CouponErrorCodes = exports.CouponErrorCodes || (exports.CouponErrorCodes = {}));
//# sourceMappingURL=coupons.js.map